export default __webpack_public_path__ + "static/media/246.0aeb8530.svg";